import React, { useEffect, useState } from "react";
import NavbarLeft from "./../Components/NavbarLeft";
import Block from "./../Components/Block.js";

// NAVIGATE
import { useNavigate } from "react-router-dom";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { signInWithEmailLink_ } from "../../redux/actions/authActions";
// import { calculEcoScore } from "../../redux/actions/analysisActions";
import { fetchUserInfo, setUserOnboardingStep, setUserOnboardingStepLocal, getFreeSubscriptionDaysLeft } from "../../redux/actions/userActions";
import firebase from "../../firebase/config";

import { fetchAnalysis, fetchLabels, fetchImpactIndicators } from "../../redux/actions/analysisActions";

import ReactGA from "react-ga";
import useAnalyticsEventTracker from "../../utils/useAnalyticsEventTracker";




const HomePage = () => {
  const navigate = useNavigate();
  const [step, setstep] = useState(1);

  // REDUX
  const dispatch = useDispatch();
  const signInWithEmailLink_rd = (item) => dispatch(signInWithEmailLink_(item));
  const fetchUserInfo_rd = () => dispatch(fetchUserInfo());
  // const auth = useSelector((state) => state.firebase.auth);

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const user_signedIn = useSelector((state) => (state.auth.signedIn ? state.auth.signedIn : null));
  const subscription = useSelector((state) => (state.user.subscription ? state.user.subscription : null));

  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));
  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };
  const current_period = useSelector((state) => (state.user.subscription_days_left ? state.user.subscription_days_left : null));


  const gaEventTracker = useAnalyticsEventTracker('Contact us');


  return (
    <>
      <NavbarLeft currentPage={1} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10" />
      <div className="w-full h-[1550px] bg-[#F3F5F7] relative top-[70px]">
        <div className="w-[1200px] relative left-[155px] top-[50px]">
          <h1 className="font-Poppins-SemiBold text-4xl relative">Bienvenue !</h1>
          <div className="h-[450px]">
            <div className="text-2xl relative top-[50px] left-0 w-[675px] flex justify-center">
              <h1 className="font-Poppins-SemiBold">Analyser</h1>
              <h1 className="font-Poppins-Regular relative left-2">- Réaliser une ACV complète et personnalisée</h1>
            </div>

            {/* <p onClick={() => {
              console.log("TRACKING", process.env.REACT_APP_NODE_ENV)
               
              gaEventTracker('Test')
            }}>
              TOTO
            </p> */}

            <div className="w-[1200px] h-[335px] relative top-[80px] left-0 flex">
              <div className="relative left-[0px]">
                <Block navigate={navigate} text="Choisir un produit de référence\n" video={0} linkedto="AnalysisProduceChoice" number={1} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[50px]">
                <Block navigate={navigate} text="Personnaliser\nles étapes d'analyse" video={0} linkedto="AnalysisHistory" number={2} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[100px]">
                <Block navigate={navigate} text="Valider un process\ndu Cycle de Vie" video={0} linkedto="AnalysisHistory" number={3} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
            </div>
            <div className="text-2xl relative top-[150px] left-0 w-[525px] flex justify-center">
              <h1 className="font-Poppins-SemiBold">Réduire</h1>
              <h1 className="font-Poppins-Regular relative left-2">- Identifier les leviers d'amélioration</h1>
            </div>
            <div className="w-[1200px] h-[335px] relative top-[180px] left-0 flex">
              <div className="relative left-[0px]">
                <Block navigate={navigate} text="Choisir une analyse\n à réduire" video={0} linkedto="ReduceScenarioChoice" number={4} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[50px]">
                <Block navigate={navigate} text="Définir les critères\nd'optimisation" video={0} linkedto="ReduceParametersChoice" number={5} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[100px]">
                <Block navigate={navigate} text="Recherche des\nscénarios optimales" video={0} linkedto="ReduceParametersChoice" number={6} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
            </div>
            <div className="text-2xl relative top-[250px] left-0 w-[645px] flex justify-center">
              <h1 className="font-Poppins-SemiBold">Communiquer</h1>
              <h1 className="font-Poppins-Regular relative left-2">- Générer des rapports automatiques</h1>
            </div>
            <div className="w-[1200px] h-[335px] relative top-[280px] left-0 flex">
              <div className="relative left-[0px]">
                <Block navigate={navigate} text="Générer un rapport\nautomatique" video={0} linkedto="Com" number={7} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[50px]">
                <Block navigate={navigate} text="Kit de communication\néco-score" video={0} linkedto="Com" number={8} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
              <div className="relative left-[100px]">
                <Block navigate={navigate} text="Kit de communication\nmulticritère - IME" video={0} linkedto="Com" number={9} currentStep={user_info && user_info.usage_info.onboarding_step + 1} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HomePage;
